// extracted by mini-css-extract-plugin
module.exports = {"Container":"u7SZF","Header":"AfXpH","RatingAggregate":"_1M5a6","OverallRating":"_1WyZo","ReviewListings":"_34cm1","NoReviews":"_3wv1U"};